// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"760":"c5c535b2","796":"9422bf87","945":"b6d4f877"}[chunkId] + ".chunk.js";
};